import type { ResolvedTruckCapacity } from "@shared/products/truck-capacity";

interface ShipmentCapacityProduct {
  truckCapacity: number;
  truckOptions?: ResolvedTruckCapacity[];
}

export function shipmentTruckOptions(product: ShipmentCapacityProduct) {
  return (
    product.truckOptions ?? [
      { truckType: "dryVan", capacity: product.truckCapacity },
    ]
  );
}

export function shipmentTruck(
  product: ShipmentCapacityProduct,
  shipment: { truckType?: string; quantity: number },
) {
  const options = shipmentTruckOptions(product);
  return shipment.truckType
    ? options.find((option) => option.truckType === shipment.truckType)
    : options.find((option) => option.capacity >= shipment.quantity);
}
